import { type Cents, type RetirementContributionType } from '@fruitful/types';

import { requestBuilder } from '../../http/RequestBuilder';

export interface RetirementContribution {
    taxYear: number;
    type: RetirementContributionType;
}

export interface TestICTDepositRequest {
    fromSyncteraAccountId: string;
    toApexAccountId: string;
    amountCents: Cents;
    memo?: string;
    retirementContribution?: RetirementContribution;
}

export interface ICTDepositResponse {
    completed: boolean;
    workflowId: string;
    idempotencyKey: string;
    expectedSettlementDate?: string;
    state: string; // 'PROCESSING', 'POSTED', 'REJECTED', 'PENDING_WEBHOOK', 'WORKFLOW_ERROR'
    stateMessage: string;
    stateMetadata: {
        actor: string;
        message: string;
    };
}

const useTestICTDeposit = requestBuilder.mutation<
    ICTDepositResponse,
    TestICTDepositRequest
>({
    endpoint: '/api/ict/test-ict-deposit',
    method: 'POST',
});

export default useTestICTDeposit;
